import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** @see docs/API_SYSTEM_USER.md */
export async function fetchUserDetail(id) {
  const { data: raw } = await request.get(`/system/user/${id}`);
  return parseVer4DetailResponse(raw);
}
